/* eslint-disable @typescript-eslint/no-empty-function */

import { ChangeDetectionStrategy, ChangeDetectorRef, Component, forwardRef, HostListener, inject, input, output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { FormatZipcodePipe } from '../../pipes/zipcode.pipe';
import { KeyFilter } from 'primeng/keyfilter';
import { AsyncPipe } from '@angular/common';

/**
 * Component designed to return a string of only numbers, but
 * display as a formated zip code with a dash after the first five numbers.
 */
@Component({
  selector: 'cmg-form-control-zip-code',
  templateUrl: './cmg-form-control-zip-code.component.html',
  styleUrls: ['./cmg-form-control-zip-code.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CmgFormControlZipCodeComponent),
      multi: true,
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { '[id]': 'inputId()' },
  imports: [ReactiveFormsModule, KeyFilter, FormsModule, AsyncPipe],
})
export class CmgFormControlZipCodeComponent implements ControlValueAccessor {
  private readonly _formatZipcodePipe = inject(FormatZipcodePipe);
  private readonly _cdRef = inject(ChangeDetectorRef);

  readonly inputId = input<string>(undefined);
  value: string;
  onChange: any = () => {};
  onTouched: any = () => {};
  readonly focusIn = output<boolean>();

  readonly focusOut = output<string>();
  isDisabled$: BehaviorSubject<boolean> = new BehaviorSubject(false);

  modelChange() {
    //  Show updated value with only numbers
    this._cdRef.detectChanges();
    //  Remove dashes that were added in writeValue
    const nonDashedZipCode = this.value.replace(/[^0-9]+/g, '');
    //  For dynamic changes while user types call writeValue
    this.writeValue(nonDashedZipCode);
    this.onChange(nonDashedZipCode);
  }
  registerOnChange(fn) {
    this.onChange = fn;
  }
  registerOnTouched(fn) {
    this.onTouched = fn;
  }
  setDisabledState(isDisabled: boolean) {
    this.isDisabled$.next(isDisabled);
  }
  writeValue(value: string) {
    const formattedZipCode = this._formatZipcodePipe.transform(value);
    this.value = formattedZipCode;
    this._cdRef.detectChanges();
  }

  @HostListener('focusin', ['$event'])
  onFocusIn() {
    this.focusIn.emit(true);
  }

  @HostListener('focusout', ['$event'])
  onFocusOut() {
    this.focusOut.emit(this.value);
  }
}
